import PickOneTreasureBonusRecord from 'integration/pickone-treasure-bonus-record';
import { Signal } from 'signals';
import { FadeIn, ZoomIn } from 'slotworks/graphics/animation/base-animations';
import canvasManager, { Orientation } from 'slotworks/graphics/canvas/canvas-manager';
import Layers from 'slotworks/graphics/layers/layers';
import GameState from 'slotworks/model/game-state';
import Contract from 'slotworks/utils/contract';
import deviceInfo from 'slotworks/utils/device-info';
import Timer from 'slotworks/utils/timer';
import * as TweenJS from 'slotworks/utils/tween';
import particles = require('pixi-particles');
import soundManager from 'slotworks/sound/sound-manager';
import currency from 'slotworks/i18n/currency';
import BetModel from 'slotworks/model/bets/bet-model';
import Components from 'slotworks/components/components';
import gameState from 'slotworks/model/game-state';
import WildSticky from 'states/wild-sitcky';
import doSettingsModel from 'model/do-settings-model';
import { PIXIElement } from 'slotworks/graphics/pixi/group';

export default class TreasureBonusComponent {
    public onClicked: Signal = new Signal();
    private onComplete: Function;
    public static treasureBonusValue = 0;
    private bonusParticle: particles.Emitter;

    public start(): Contract<void> {
        deviceInfo.onLayoutChange.remove(this.onOrientationChange, this);
        Layers.Bonus.setScene('bonus').execute();
        Layers.Bonus.show();
        WildSticky.setBaseContainerVisibility(false);
        soundManager.customEvent("treasure_bonus_enter");
        soundManager.customEvent("enter_scene_BonusBackground_bonus");
        Components.betBar.setBalance(gameState.getCurrentGame().startBalance);
        this.setVisual();
        this.initLastRecordProperties();
        ZoomIn(Layers.Bonus.container, 150, 0, TweenJS.Easing.Quadratic.Out).execute();

        if (!deviceInfo.isDesktop) {
            deviceInfo.onLayoutChange.add(this.onOrientationChange, this);
        }

        return new Contract(resolve => {
            this.onComplete = resolve;
        });
    }

    public end() {
        deviceInfo.onLayoutChange.remove(this.onOrientationChange, this);
    }

    private setVisual() {
        this.bonusParticle = Layers.Bonus.getParticle('bonus_spark');
        if (!this.bonusParticle) return;

        this.bonusParticle.emit = false;
        for (let i = 1; i <= 15; i++) {
            const boxOpenAnimation = Layers.Bonus.getAnimatedSprite('box_open_animation_' + i);
            const boxLoopAnimation = Layers.Bonus.getAnimatedSprite('box_loop_animation_' + i);
            const chestGlowAnimation = Layers.Bonus.getAnimatedSprite('bonus_chest_glow_' + i);
            const value = Layers.Bonus.getAnimatedSprite('value_' + i);
            const chest = Layers.Bonus.getSprite('chest_' + i);
            boxOpenAnimation.visible = false;
            boxLoopAnimation.visible = false;
            chestGlowAnimation.visible = false;
            value.visible = false;
            chest.buttonMode = true;
            chest.interactive = true;
            chest.removeAllListeners();
            chest.addListener('pointerup', () => {
                this.onClicked.dispatch(i);
            });
        }
    }

    public setAllButtonActive(value: boolean) {
        for (let i = 1; i <= 15; i++) {
            const chest = Layers.Bonus.getSprite('chest_' + i);
            chest.buttonMode = value;
            chest.interactive = value;
        }
    }

    public onOrientationChange() {
        const record = GameState.getCurrentGame().getCurrentRecord();
        const r = record.getResultsOfType(PickOneTreasureBonusRecord) as PickOneTreasureBonusRecord[];
        const bonusRecord: any = r[0];
        
        // if (bonusRecord?.is_complete) return;
        this.setVisual();
        if (bonusRecord)
        this.initLastRecordProperties();
    }

    private initLastRecordProperties() {
        const record = GameState.getCurrentGame().getCurrentRecord();
        const r = record.getResultsOfType(PickOneTreasureBonusRecord) as PickOneTreasureBonusRecord[];
        const bonusRecord = r[0];
        if (!bonusRecord || !bonusRecord?.pickedOptions || bonusRecord.is_complete) {
            return;
        }

        Object.keys(bonusRecord.pickedOptions).forEach((index: any) => {
            const buttonIndex = parseInt(index) + 1;
            const chest = Layers.Bonus.getAnimatedSprite('chest_' + buttonIndex);
            const chestValue = Layers.Bonus.getBitmapText('value_' + buttonIndex);
            const chestGlowAnimation = Layers.Bonus.getAnimatedSprite('bonus_chest_glow_' + buttonIndex);
            const boxLoopAnimation = Layers.Bonus.getAnimatedSprite('box_loop_animation_' + buttonIndex);
            ZoomIn(chestValue, 400, 0, TweenJS.Easing.Bounce.Out).execute();
            ZoomIn(chestGlowAnimation, 400, 0, TweenJS.Easing.Bounce.Out).execute();
            boxLoopAnimation.visible = true;
            chest.visible = false;
            chestValue.visible = true;
            chestValue.position.x += 15;
            chestValue.position.y += 15;
            chestGlowAnimation.position.y += 15;
            chestGlowAnimation.visible = true;
            chestValue.text = this.getBonusAwardValue(bonusRecord.pickedOptions[index]);
        });
    }

    public populateResultsAndShow(buttonIndex: number) {
        this.bonusParticle.resetPositionTracking();
        this.bonusParticle.cleanup();
        const record = GameState.getCurrentGame().getCurrentRecord();
        const r = record.getResultsOfType(PickOneTreasureBonusRecord) as PickOneTreasureBonusRecord[];
        const bonusRecord: any = r[0];
        this.setAllButtonActive(false);
        const boxOpenAnimation = Layers.Bonus.getAnimatedSprite('box_open_animation_' + buttonIndex);
        const chest = Layers.Bonus.getAnimatedSprite('chest_' + buttonIndex);
        const boxLoopAnimation = Layers.Bonus.getAnimatedSprite('box_loop_animation_' + buttonIndex);
        const chestGlowAnimation = Layers.Bonus.getAnimatedSprite('bonus_chest_glow_' + buttonIndex);
        const chestValue = Layers.Bonus.getBitmapText('value_' + buttonIndex);
        chestValue.position.set(chest.position.x + 30, chest.position.y + 20);
        boxOpenAnimation.visible = true;
        chestValue.text = this.getBonusAwardValue(bonusRecord.pickedOptions[buttonIndex-1]);
        chest.visible = false;
        chestValue.visible = true;
        chestValue.position.y += 15;
        chestValue.position.x -= 15;
        chestGlowAnimation.position.y += 15;
        this.bonusParticle.emit = true;
        this.bonusParticle.parent.position.set(chest.position.x - 145, chest.position.y - 50);
        if (canvasManager.orientation === Orientation.PORTRAIT) {
            this.bonusParticle.parent.position.y -= 50;
        }
        ZoomIn(chestValue, 400, 400, TweenJS.Easing.Bounce.Out).execute();
        ZoomIn(chestGlowAnimation, 400, 400, TweenJS.Easing.Bounce.Out).execute();
        boxOpenAnimation.gotoAndPlay(0);
        soundManager.customEvent('Chest_Open');
        boxOpenAnimation.animationSpeed = 1.2;
        chestGlowAnimation.visible = true;
        chestGlowAnimation.gotoAndPlay(0);
        Timer.setTimeout(() => {
            boxLoopAnimation.gotoAndPlay(0);
            if (bonusRecord.is_complete) {
                this.playCompleteAnimation(bonusRecord);
                Timer.setTimeout(() => {
                    soundManager.customEvent('Chest_Match_Award');
                    this.bonusParticle.emit = false;
                    deviceInfo.onLayoutChange.remove(this.onOrientationChange);
                    this.onComplete();
                }, 1200);
            } else {
                this.setAllButtonActive(true);
            }
        }, 500);
    }

    private getBonusAwardValue(value: number): string {
        if(doSettingsModel.isCurrentBonusBuyOut) {
            return currency.formatValue(value * doSettingsModel.totalBetOnBuyoutBonus);
        }
        const currentBet = BetModel.getTotalBet();
        return currency.formatValue(value * currentBet);
    }

    private playCompleteAnimation(bonusRecord: PickOneTreasureBonusRecord) {
        Layers.BonusForeground.setScene('bonus').execute();
        Layers.BonusForeground.show();
        const filter = Layers.BonusForeground.getSprite('filter');
        filter.visible = true;
        FadeIn(filter, 500).execute();
        let pickedValues: Map<number, number[]> = new Map<number, number[]>();
        let buttonIndexes: number[] = [];
        Object.keys(bonusRecord.pickedOptions).forEach(function(index) {
            const value = bonusRecord.pickedOptions[index];
            let values: number[] = [];
            if (pickedValues.has(value)) {
                values = pickedValues.get(value);
            }
            values.push(parseInt(index));
            pickedValues.set(bonusRecord.pickedOptions[index], values);
            if (values.length === 3) {
                buttonIndexes = values;
            }
        });

        for (let buttonIndex = 1; buttonIndex <= 15; buttonIndex++) {
            let chestGlowAnimation = Layers.Bonus.getAnimatedSprite('bonus_chest_glow_' + buttonIndex);
            let boxLoopAnimation = Layers.Bonus.getAnimatedSprite('box_loop_animation_' + buttonIndex);
            let chestValue = Layers.Bonus.getBitmapText('value_' + buttonIndex);
            if (buttonIndexes.indexOf(buttonIndex - 1) <= -1) {
                new TweenJS.Tween(chestGlowAnimation).to({ alpha: 0 }, 500).start();
                boxLoopAnimation.loop = false;
            } else {
                boxLoopAnimation.visible = true;
                Layers.BonusForeground.add(boxLoopAnimation);                
                Layers.BonusForeground.add(chestGlowAnimation);
                Layers.BonusForeground.add(chestValue);
                boxLoopAnimation.x -= Layers.Bonus.container.pivot.x;
                boxLoopAnimation.y -= Layers.Bonus.container.pivot.y;
                chestGlowAnimation.x -= Layers.Bonus.container.pivot.x;
                chestGlowAnimation.y -= Layers.Bonus.container.pivot.y;
                chestValue.x -= Layers.Bonus.container.pivot.x;
                chestValue.y -= Layers.Bonus.container.pivot.y;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/treasure-bonus-component.ts